import AntiSpam from './AntiSpam.ts';
import initAntiSpam from './initAntiSpam.ts';

export{
    AntiSpam,
    initAntiSpam
}